import React, { useEffect, useState } from "react";
import "./TypeOfCrops.css";
import { Box, Grid, Typography } from "@mui/material";
import { crops } from "../../config/images";
import { useNavigate } from "react-router-dom";
import { getTypeOfCrops } from "../../config/services";
import translations from "../../config/language";

const Crops = () => {
  const [cropsData, setCropsData] = useState([]);

  useEffect(() => {
    handleCropsData();
  }, []);

  const handleCropsData = async () => {
    try {
      const resp = await getTypeOfCrops();
      if (resp.status == 200 || resp.status == 201) {
        setCropsData(resp.data.results.payload);
      }
    } catch (error) {
      setCropsData([]);
    }
  };
  const navigate = useNavigate();
  const language = process.env.REACT_APP_LANGUAGE;
  return (
    <>
      <Box className="task-detail-box">
        <Box className="d-flex justify-content-between align-items-center">
          <Box className="d-flex  gap-3 img-box" style={{ padding: "25px" }}>
            <img
              src={crops.crops}
              alt=""
              // style={{ height: "44px", width: "44px" }}
            />
            <Typography variant="h6" gutterBottom>
              {translations[language].typesOfCrops}
            </Typography>
          </Box>
        </Box>
        <Grid container spacing={3} className="p-3">
          {cropsData.map((e) => {
            return (
              <>
                <Grid item xs={12} sm={6} md={3}>
                  <Box
                    className="crops-data d-flex justify-content-between align-items-center"
                    onClick={() =>
                      navigate(`/crops/crops-data/${e.id}`, {
                        state: { name: e.name },
                      })
                    }
                  >
                    <Typography variant="h6">{e.name}</Typography>
                    <Typography variant="h5">
                    {String(e?.counts).padStart(2, "0")}
                    </Typography>
                  </Box>
                </Grid>
              </>
            );
          })}
        </Grid>
      </Box>
    </>
  );
};

export default Crops;
